// extracted by mini-css-extract-plugin
export var measureBox = "_1c-0";